<template>
    <div class="flex justify-center">
        <transition name="slide-swap">
            <router-view id="myrouter"></router-view>
        </transition>
    </div>
</template>

<script>
import CouponModule from '@/store/coupon'
export default {
    name: 'coupon-main',
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {},
    created() {
        this.$store.register(CouponModule)
    },
    beforeDestroy() {
        this.$store.unregister(CouponModule)
    }
}
</script>

<style scoped>
h2 {
    /* color: #6a6e6e; */
}
</style>
